import { gql } from '@apollo/client';

export const COMPONENT_LIST_SET_CREATE = gql`
    mutation CreateComponentListSet( $input: CreateComponentListSetInput! ) {
        createComponentListSet( input: $input ) {
            componentListSetId
            type
            name
            description
            isPublished
            componentLists
            createdAt
            updatedAt
        }
    }
`;

export default COMPONENT_LIST_SET_CREATE;
